export const DOCUMENT_TYPE_SERVICE_LANDING_PAGE = 'serviceLandingPage';
